//common
import './common';

//components
import './blocks/slider-banner-main'
import './blocks/filter'


import './blocks/dropdown-input'
import RecipesCarousel from './blocks/slider-recipes'
import NewRecipesCarousel from './blocks/slider-new-recipes'
import './blocks/pagination'
import search from './blocks/search';


addEventListener('ajax:update-complete', () => {
    RecipesCarousel.init();
    NewRecipesCarousel.init();
    search.initHandler();
})